export default {
  intentOverview: "अवलोकन",
  intentAnalytic: "विश्लेषण",
  intentFilter: "फ़िल्टर",
  savedCompanyWebsite: "सहेजी गई कंपनी की वेबसाइट",
  companiesFound: "कंपनियां मिलीं",
  companyFound: "कंपनी मिली",
  selectLists: "सूचियाँ चुनें...",
  chooseARangeOfTime: "समय की एक सीमा चुनें",
  greaterThan: "से अधिक",
  // intentIndustry: 'उद्योग',
  tabActivity: "गतिविधि",
  tabOverview: "अवलोकन",
  tabEmployees: "कर्मचारी",
  tabContacts: "सामान्य संपर्क",
  tabTechnologies: "प्रौद्योगिकियाँ",
  intentStatistic: "सांख्यिकी",
  intentCampaign: "अभियान",
  newVisitors: "नए आगंतुक",
  recurringVisitors: "बार-बार आने वाले आगंतुक",
  mediocreLead: "साधारण लीड",
  sessionsTracked: "ट्रैक किए गए सत्र",
  sessionTracked: "ट्रैक किया गया सत्र",
  lastSeenOn: "पिछली बार देखा गया: ",
  firstSeenOn: "पहली बार देखा गया: ",
  viewTrackedWebSession: "ट्रैक किया गया वेब सत्र देखें",
  webSession: "वेब सत्र",
  client: "ग्राहक",
  timeSpent: "व्यतीत किया गया समय",
  pageviews: "पेज व्यू",
  pageview: "पेज व्यू",
  referrer: "रेफरर",
  sessions: "सत्र",
  session: "सत्र",
  visited: "दौरा किया गया",
  AM: "पूर्वाह्न",
  PM: "अपराह्न",
  companyDetails: "कंपनी का विवरण",
  overviewList: {
    location: "स्थान",
    industry: "उद्योग",
    founded: "स्थापित",
    ranking: "रैंकिंग",
    size: "आकार",
    revenue: "अनुमानित राजस्व",
    keywords: "कीवर्ड",
  },
  jobFunction: "नौकरी का कार्य",
  employeeLocation: "स्थान",
  contactEmail: "ईमेल",
  categoryAndTechnology: "श्रेणी और प्रौद्योगिकी",
  firstDetected: "पहली बार पता चला",
  lastDetected: "पिछली बार पता चला",
  saved: "सहेजा गया",
  addToContactList: "संपर्क सूची में जोड़ें",
  noCampaignIdentified: "कोई अभियान पहचान नहीं हुई",
  copyEmail: "ईमेल कॉपी करें",
  willBeSavedToTheFollowingSelectedLists:
    "निम्नलिखित चयनित सूचियों में सहेजा जाएगा:",
  addToLists: "सूचियों में जोड़ें",
  noDataToDisplay: "प्रदर्शित करने के लिए कोई डेटा नहीं",
  intentFounded: "स्थापित",
  intentIndustry: "उद्योग",
  intentLocation: "स्थान",
  intentRanking: "रैंकिंग",
  noDetailsAvailableRightNow : "अभी कोई विवरण उपलब्ध नहीं है, बाद में फिर से देखें।",
  intentSize: "आकार",
  applyFilters: "फ़िल्टर लागू करें",
  youCanEditTheseFilters:
    "आप अपने परिणामों को परिष्कृत करने के लिए इन फ़िल्टरों को कभी भी संपादित कर सकते हैं",
  installB2BDirectLeadFinder: "अपनी साइट पर B2B Direct Lead Finder इंस्टॉल करें",
  addSite: "अपनी साइट जोड़ें",
  areYouSureYouWantToRemoveThisWebsite:
    "क्या आप वाकई इस वेबसाइट को हटाना चाहते हैं?",
  Cancel: "रद्द करें",
  installB2BLeadFinder: "B2B लीड फाइंडर इंस्टॉल करें",
  siteUrl: "साइट URL",
  copyToClipboard: "क्लिपबोर्ड पर कॉपी करें",
  pleaseSelectAContactFirst: "कृपया पहले एक संपर्क चुनें",
  pasteCodeBelowIntoTheHead: "नीचे दिए गए कोड को",
  ofEveryPageYouWishToTrackVisitorOn:
    "हर उस पेज के <head> सेक्शन</head> में पेस्ट करें जिस पर आप आगंतुकों को ट्रैक करना चाहते हैं।",
  forWordpressWeRecommendInstalling:
    "वर्डप्रेस के लिए, हम Stefano Lissa से",
  pluginFromStefanoLissa: "प्लगइन इंस्टॉल करने की सलाह देते हैं।",
  afterInstallingAndActivating:
    "प्लगइन इंस्टॉल और सक्रिय करने के बाद, अपने वर्डप्रेस डैशबोर्ड में",
  inYourWordPressDashboard: "पर जाएं।",
  youWillSeeANumberOfTabs:
    "आपको प्लगइन के इंटरफ़ेस में कई टैब दिखाई देंगे। सुनिश्चित करें कि आप डिफ़ॉल्ट 'हेड और फुटर' टैब में हैं, फिर निम्न कोड स्निपेट को कॉपी और पेस्ट करें:",
  settingHeaderAndFooter: "सेटिंग्स → हेडर और फुटर",
  dontForgetToClearYourCache: "अपना कैश साफ़ करना न भूलें",
  ifYouAreUsingAnyCaChing: "यदि आप कोई भी कैशिंग प्लगइन जैसे",
  orSimilar:
    "या इसी तरह का उपयोग कर रहे हैं, तो कोड स्निपेट स्थापित करने के बाद कैश को साफ़ करना सुनिश्चित करें!",
  GTMshouldAlreadyBeInstalled:
    "इन निर्देशों का पालन करने से पहले Google Tag Manager पहले से ही आपकी साइट पर स्थापित होना चाहिए",
  ifYouDontHaveGTM:
    "यदि आपके पास अभी तक Google Tag Manager स्थापित नहीं है, तो आप",
  GTMsupportArticleAboutInstall:
    "Google Tag Manager सपोर्ट आर्टिकल में इसे स्थापित करने का तरीका जान सकते हैं",
  signInToGTMAndClick:
    "Google Tag Manager में साइन इन करें, और 'एक नया टैग जोड़ें' बटन पर क्लिक करें। अगला,",
  clickWhereItSays: "'",
  chooseATagTypeToBeginSetup: "सेटअप शुरू करने के लिए एक टैग प्रकार चुनें",
  andSelect: "' पर क्लिक करें और",
  fromTheList:
    "सूची से चुनें। फिर, निम्न कोड को कॉपी और पेस्ट करके टेक्स्ट फ़ील्ड में डालें:",
  nextClick: "अगला, '",
  giveTheTagAName: "' पर क्लिक करें। टैग को एक नाम दें और फिर 'सहेजें' बटन पर क्लिक करें।",
  dontForgetToPublishYourChange: "अपने परिवर्तनों को प्रकाशित करना न भूलें",
  afterCreateTheCustom: "कस्टम HTML टैग बनाने के बाद, ",
  yourChanges: "अपने परिवर्तनों को प्रकाशित करना न भूलें!",
  submitAndPublish: "जमा करें और प्रकाशित करें",
  copySuccessfully: "सफलतापूर्वक कॉपी किया गया",
  addToCompanyList: "कंपनी सूची में जोड़ें",
  addToList: "सूची में जोड़ें",
  enterOrCreateList: "सूचियाँ दर्ज करें या बनाएं",
  installCode: "कोड इंस्टॉल करें",
  wordpress: "वर्डप्रेस",
  googleTagManager: "गूगल टैग मैनेजर",
  noTechAreFound: "कोई तकनीक नहीं मिली",
  updateSuccessfully: "सफलतापूर्वक अपडेट किया गया",
  enterJobFunction: "नौकरी का कार्य दर्ज करें",
  pinSuccessfully: "सफलतापूर्वक पिन किया गया",
  cancelPinSuccessfully: "सफलतापूर्वक अनपिन किया गया",
  adsName: "विज्ञापन का नाम",
  utmTerm: "utm टर्म",
  utmCampaign: "utm अभियान",
  utmSource: "utm स्रोत",
  utmMedium: "utm माध्यम",
  enterNumber: "संख्या दर्ज करें",
  enterName: "नाम दर्ज करें",
  enterJobTitle: "नौकरी का शीर्षक दर्ज करें",
  areYouSureYouWantToRemovePeopleOfThisGroup:
    "क्या आप वाकई इस समूह के लोगों को हटाना चाहते हैं",
  areYouSureYouWantToRemoveCompanyOfThisGroup:
    "क्या आप वाकई इस समूह की कंपनी को हटाना चाहते हैं",
  byCancelingYouEnsureThatNoPeopleWillBeRemoved:
    "रद्द करके, आप सुनिश्चित करते हैं कि कोई भी व्यक्ति हटाया नहीं जाएगा",
  byCancelingYouEnsureThatNoCompanyWillBeRemoved:
    "रद्द करके, आप सुनिश्चित करते हैं कि कोई भी कंपनी हटाई नहीं जाएगी",
  howToGetStarted: "शुरुआत कैसे करें",
  Data: "डेटा",
  deactivateWebsite: "वेबसाइट निष्क्रिय करें",
  areYouCertainAboutDeactivatinYourWebsite:
    "क्या आप वाकई अपनी वेबसाइट को निष्क्रिय करना चाहते हैं? ध्यान रखें कि इसके परिणामस्वरूप आपको किसी भी संभावित कंपनी गतिविधि की जानकारी नहीं मिलेगी।",
  byCancelingYouWillContinueToActivateAndUse:
    "रद्द करके, आप इस उपकरण को सक्रिय रखना और उपयोग करना जारी रखेंगे",
  btnDeactivateNow: "अभी निष्क्रिय करें",
  yourTrialHasEnded: "आपका परीक्षण समाप्त हो गया है",
  reactivateNow: "अभी पुनः सक्रिय करें",
  yourWebsiteHasBeenAutomaticallyInactivated:
    "आपकी वेबसाइट स्वतः ही निष्क्रिय हो गई है। क्या आप डेटा की निगरानी जारी रखने के लिए इस उपकरण को पुनः सक्रिय करना चाहेंगे?",
  Inactivated: "निष्क्रिय",
  onTrial: "परीक्षण पर",
  Active: "सक्रिय",
  youAreOnTrail: "आप 7-दिन के परीक्षण पर हैं",
  yourTrailHasEnded: "आपका परीक्षण समाप्त हो गया है",
  createNewWebIntent: "नया वेब इरादा बनाएं",
  clickOnTheButton: "1. (+) बटन पर क्लिक करें",
  typeInUrlOrWebAddress: "2. URL या वेब पता टाइप करें",
  theTrialWillActivate: "इस साइट का 7-दिन का निःशुल्क ट्रायल सक्रिय करें",
  siteUrlMustStartWithHttps: "साइट URL को https या http से शुरू होना चाहिए",
  pleaseEnterASiteUrl: "कृपया एक साइट URL दर्ज करें",
  noMoreData: "और डेटा नहीं",
  pleaseEnterANewName: "कृपया एक नया नाम दर्ज करें",
  pleaseSelectASearchName: "कृपया एक खोज नाम चुनें",
  clickToGetEmail: "ईमेल पाने के लिए क्लिक करें",
  emailIsNotAvailable: "ईमेल उपलब्ध नहीं है",
  enterOrCreateLists: "सूचियाँ दर्ज करें या बनाएं",
  viewMore: "और देखें",
  removeFromContactList: "संपर्क सूची से हटाएं",
  willBeRemovedFromTheFollowingLists:
    "निम्नलिखित सूचियों से हटा दिया जाएगा",
  removeFromLists: "सूचियों से हटाएं",
  pleaseSelectOrCreateAList: "कृपया एक सूची चुनें या बनाएं",
  chooseATriggerToMakeThisTagFire: "इस टैग को फायर करने के लिए एक ट्रिगर चुनें...",
  youWontBeChargedYet: "आपसे अभी शुल्क नहीं लिया जाएगा",
  youDontHaveEnoughCredits: "आपके पास पर्याप्त क्रेडिट नहीं हैं",
  ThisEmailRequire: "इस ईमेल के लिए",
  TheseEmailsRequires: "इन ईमेलों के लिए",
  intentCredit: "क्रेडिट की आवश्यकता है",
  intentCredits: "क्रेडिट की आवश्यकता है",
  companyOverview: 'कंपनी अवलोकन',

  // 新UI
  companyInsight: "कंपनी अंतर्दृष्टि",
  companiesDetailHeader: "कंपनियां",
  updateData: "डेटा अपडेट करें",
  discoverYourLeads: "अपनी लीड्स खोजें",
  similarCompanies: "समान कंपनियां",
  companyEmployees: "कर्मचारी"
};